import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import GavelOutlinedIcon from '@mui/icons-material/GavelOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import { ArtefactType } from './types';

export interface ArtefactMeta {
  icon: typeof DescriptionOutlinedIcon;
  label: string;
  order: number;
}

export const ARTEFACT_META: Record<ArtefactType, ArtefactMeta> = {
  'case-overview': { icon: DescriptionOutlinedIcon, label: 'Case Overview', order: 1 },
  'parties-and-players': { icon: PeopleOutlinedIcon, label: 'Parties & Players', order: 2 },
  timeline: { icon: TimelineOutlinedIcon, label: 'Timeline', order: 3 },
  issues: { icon: GavelOutlinedIcon, label: 'Legal Issues', order: 4 },
  'glossary-and-aliases': { icon: MenuBookOutlinedIcon, label: 'Glossary', order: 5 },
  'open-questions': { icon: HelpOutlineOutlinedIcon, label: 'Open Questions', order: 6 },
};
